interface LoaderProps {
  message?: string;
  height?: string;
}

function Loader({ message, height = 'h-[70vh]' }: LoaderProps) {
  return (
    <div className={`${height} flex items-center justify-center`}>
      <div className='text-center'>
        <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-brand-primary-color mx-auto mb-3' />
        {message && <p className='text-sm text-content-secondary'>{message}</p>}
      </div>
    </div>
  );
}

export default Loader;
